module.exports = __webpack_public_path__ + "img/logo_login_inferiore.957c769e.png";